module.exports = __webpack_public_path__ + "assets/img/Type E (62).9210c565.jpg";